<template>
    <a :href="href" ><slot></slot></a>
</template>

<script>
export default {
  name: 'VueLink',
  data () {
    return {
      href: '',
    };
  },
  props: {
    spa: {
      type: Boolean,
      default: false,
    }, // 跳转是否新开页面  默认不新开
    replace: {
      type: Boolean,
      default: false,
    }, // 跳转是否新开页面  默认不新开
    to: {
      type: Object,
      default: {path: '', },
    }, // 页面跳转传参数
  },
  watch: {
    to () {
      this.gohref();
    },
  },
  methods: {
    gohref () {
      if (this.to.query) { // 说明可能有参数
        let index = 0, str = '';
        for (let key in this.to.query) {
          str += `${key}=${this.to.query[key]}&`;
          index++;
        }
        if (index) {
          str = str.slice(0, str.length - 1);
        }
        if (str == '') { // 说明是没有参数
          this.href = this.to.path;
        } else { // 说明是有参数
          this.href = this.to.path + '?' + str
        }
      } else { // 说明没有参数
        this.href = this.to.path;
      }
    },
  },
  mounted () {
    this.gohref();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// VueLink.vue